/**
 * Check if app is running on production Marley instance
 * Returns true only when IS_PRODUCTION_MARLEY_INSTANCE is true
 * and MARLEY_ACTIVE_ACCOUNT does not include 'uat'
 */
// eslint-disable-next-line import/prefer-default-export
export const isProductionMarleyInstance = (): boolean => {
  // In production, webpack DefinePlugin injects a boolean directly.
  const flagValue = process.env.IS_PRODUCTION_MARLEY_INSTANCE as unknown as
    | boolean
    | string;
  const isProduction = flagValue === true || flagValue === 'true';
  const activeAccount = process.env.MARLEY_ACTIVE_ACCOUNT ?? '';
  const isUat = activeAccount.toLowerCase().includes('uat');
  return isProduction && !isUat;
};
